import AdvisoryContent from './AdvisoryContent.jsx';
import './style.scss';

export {
  AdvisoryContent
};



// WEBPACK FOOTER //
// ./components/users/sub-view/advisory-content/index.js